module.exports = __webpack_public_path__ + "img/dispute-background-ornament.64d8ef4a.svg";